module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Insertion":"Einblendung"}}')
  delete Component.options._Ctor
}
